import React from 'react';
import {CircularProgress, Stack} from "@mui/material";

const LoadingScreen = () => {
    return (
        <Stack
            direction={"column"}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{
                position: "absolute",
                height: "100%",
                width: "100%",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                bgcolor: "#FFF",
                zIndex: 100000
            }}
        >
            <CircularProgress/>
        </Stack>
    );
};

export default LoadingScreen;
